/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMensesEvents } from 'app/entities/menses-event/menses-event.reducer';
import { DayType } from 'app/shared/model/enumerations/day-type.model';
import { Mood } from 'app/shared/model/enumerations/mood.model';
import { CycleStatus } from 'app/shared/model/enumerations/cycle-status.model';
import { createEntity, getEntity, reset, updateEntity } from './cycle-day.reducer';

export const CycleDayUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const mensesEvents = useAppSelector(state => state.mensesEvent.entities);
  const cycleDayEntity = useAppSelector(state => state.cycleDay.entity);
  const loading = useAppSelector(state => state.cycleDay.loading);
  const updating = useAppSelector(state => state.cycleDay.updating);
  const updateSuccess = useAppSelector(state => state.cycleDay.updateSuccess);
  const dayTypeValues = Object.keys(DayType);
  const moodValues = Object.keys(Mood);
  const cycleStatusValues = Object.keys(CycleStatus);

  const handleClose = () => {
    navigate(`/cycle-day${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMensesEvents({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.desireScale !== undefined && typeof values.desireScale !== 'number') {
      values.desireScale = Number(values.desireScale);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...cycleDayEntity,
      ...values,
      event: mensesEvents.find(it => it.id.toString() === values.event?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          dayType: 'START',
          mood: 'HAPPY',
          status: 'ESTIMATED',
          ...cycleDayEntity,
          event: cycleDayEntity?.event?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.cycleDay.home.createOrEditLabel" data-cy="CycleDayCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.cycleDay.home.createOrEditLabel">Create or edit a CycleDay</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="cycle-day-id"
                  label={translate('tinyMedicRestApp.cycleDay.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.dayType')}
                id="cycle-day-dayType"
                name="dayType"
                data-cy="dayType"
                type="select"
              >
                {dayTypeValues.map(dayType => (
                  <option value={dayType} key={dayType}>
                    {translate(`tinyMedicRestApp.DayType.${dayType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.mood')}
                id="cycle-day-mood"
                name="mood"
                data-cy="mood"
                type="select"
              >
                {moodValues.map(mood => (
                  <option value={mood} key={mood}>
                    {translate(`tinyMedicRestApp.Mood.${mood}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.moodNotes')}
                id="cycle-day-moodNotes"
                name="moodNotes"
                data-cy="moodNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.desireScale')}
                id="cycle-day-desireScale"
                name="desireScale"
                data-cy="desireScale"
                type="text"
                validate={{
                  min: { value: 1, message: translate('entity.validation.min', { min: 1 }) },
                  max: { value: 10, message: translate('entity.validation.max', { max: 10 }) },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.status')}
                id="cycle-day-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {cycleStatusValues.map(cycleStatus => (
                  <option value={cycleStatus} key={cycleStatus}>
                    {translate(`tinyMedicRestApp.CycleStatus.${cycleStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.comments')}
                id="cycle-day-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.active')}
                id="cycle-day-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.draft')}
                id="cycle-day-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.cursor')}
                id="cycle-day-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.lastUpdated')}
                id="cycle-day-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.microSec')}
                id="cycle-day-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cycleDay.timestampEntry')}
                id="cycle-day-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="cycle-day-event"
                name="event"
                data-cy="event"
                label={translate('tinyMedicRestApp.cycleDay.event')}
                type="select"
              >
                <option value="" key="0" />
                {mensesEvents
                  ? mensesEvents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/cycle-day" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CycleDayUpdate;
